<template>
  <Layout>
    <PageHeader :title="page.title" :items="page.items" />

    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <b-col lg="4">
              <b-form-group
                label="Question Group"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="title"
              >
                <b-form-input
                  id="title"
                  v-model="search_condition.problemGroupName"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                label="Question Category"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="category"
              >
                <b-form-select
                  v-model="search_condition.problemTypeId"
                  :options="types.questionCategorys"
                  value-field="id"
                  text-field="typeName"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                label="Status"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="status"
              >
                <b-form-select
                  v-model="search_condition.status"
                  :options="types.statuss"
                  value-field="value"
                  text-field="text"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <!-- 所属客户 -->
            <b-col lg="4">
              <b-form-group
                label="Affiliated Customer"
                label-cols-lg="4"
                label-align-lg="right"
                label-for="customer"
              >
                <b-form-select
                  id="customer"
                  v-model="search_condition.supplierId"
                  :options="types.allSupplier"
                  value-field="id"
                  text-field="brandName"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <!-- table -->
          <b-button
            v-has="'researchQuestions::Create'"
            @click="gotoAdd"
            variant="primary"
            >Create</b-button
          >
          <div class="table-responsive mb-0">
            <b-table
              show-empty
              empty-text="No records"
              id="table"
              head-variant="light"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">
                {{
                  data.index +
                    (search_condition.pageNum - 1) * search_condition.pageSize +
                    1
                }}
              </template>

              <template v-slot:cell(actions)="row">
                <b-button-group>
                  <b-button
                    v-has="'researchQuestions::Modify'"
                    size="sm"
                    variant="info"
                    @click="edit(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Modify
                  </b-button>
                  <b-button
                    v-has="'researchQuestions::Disable'"
                    v-if="row.item.status"
                    size="sm"
                    variant="danger"
                    @click="enableOrDisable(row.item, row.index, $event.target)"
                    class="mr-1"
                    >Disable</b-button
                  >
                  <b-button
                    v-has="'researchQuestions::Enable'"
                    v-else
                    size="sm"
                    variant="info"
                    @click="enableOrDisable(row.item, row.index, $event.target)"
                    class="mr-1"
                    >Enable</b-button
                  >
                </b-button-group>
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination  mb-0" v-if="rows != 0">
                  <b-pagination
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  >
                  </b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import timeZoneConversion from "@/components/widgets/timeZoneConversion";

/**
 * FAQ component
 */
export default {
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },
  data() {
    return {
      page: {
        title: "Research Questions",
        items: [
          {
            text: "UNI-CORE",
            // href: "/"
          },
          {
            text: "Medical Manage",
            // href: "/"
          },
          {
            text: "Research Questions",
            active: true,
          },
        ],
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        {
          key: "problemGroupName",
          label: "Question Group",
          class: "text-center",
        },
        {
          key: "typeName",
          label: "Question Category",
          class: "text-center",
        },
        {
          key: "status",
          label: "Status",
          formatter: (value) => {
            return value == 1 ? "Enabled" : "Disabled";
          },
        },
        {
          key: "supplierName",
          label: "Affiliated Customer",
          class: "text-center",
        },
        { key: "remarks", label: "Remarks", class: "text-center" },
        {
          key: "createTime",
          label: "Create Time",
          class: "text-center",
          formatter: (value) => {
            if (value) {
              return timeZoneConversion.getLocalTime(value);
            } else {
              return "";
            }
          },
        },
        { key: "actions", label: "Opreration", class: "text-center" },
      ],
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        problemTypeId: "",
        status: "",
        problemGroupName: "",
        supplierId: "",
      },
      isBusy: false,
      has_data: false,
      types: {
        statuss: [
          { text: "Please select", value: "", disabled: false },
          { text: "Enabled", value: 1, disabled: false },
          { text: "Disabled", value: 0, disabled: false },
        ],
        questionCategorys: [{ id: "", typeName: "Please select" }],
        allSupplier: [{ brandName: "Please select", id: "" }],
      },
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {
    this.init();
  },
  created() {},
  methods: {
    init() {
      this.$api.medicalManage
        .selectAllProblemType()
        .then((res) => {
          if (res.success) {
            this.types.questionCategorys = this.types.questionCategorys.concat(
              res.data
            );
          }
        });
        this.$api.Dropdown.selectAllSupplier().then((res) => {
        if (res.success && res.data) {
          this.types.allSupplier = this.types.allSupplier.concat(res.data);
        } else {
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    gotoAdd() {
      this.$router.push("researchQuestionsAdd");
    },
    provider(ctx) {
      this.isBusy = true;
      return this.$api.medicalManage
        .selectAllProblemGroup(this.search_condition, ctx)
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    edit(item, index, button) {
      this.$router.push("researchQuestionsEdit?id=" + item.id);
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
    },
    // 停用启用
    enableOrDisable(a, b, c) {
      this.$api.medicalManage
        .enableOrDisableProblemGroup({
          id: a.id,
          status: a.status === 0 ? 1 : 0,
        })
        .then((res) => {
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
          if (res.success) {
            this.$refs.table.refresh();
          }
        });
    },
  },
};
</script>
